import { computed, makeObservable } from 'mobx'

import { Model } from 'modules/core/lib/mobx-rest'

import { ICustomField } from 'modules/custom_resources/store/models/customFields/Field'

export interface ITemplateQuestion {
  id: string
  surveys_questions_template_id: string
  surveys_questions_template_category_id: string
  position: number
  custom_field: ICustomField
}

class TemplateQuestion extends Model<ITemplateQuestion> {
  static urlRoot() {
    return '/surveys/template_questions'
  }

  constructor(attr: ITemplateQuestion) {
    super(attr)
    makeObservable(this, {
      position: computed,
    })
  }

  get position(): number {
    return this.attributes.position
  }
}

export default TemplateQuestion
